export default __webpack_public_path__ + "static/media/download.c94fc2f9.svg";